import { translate } from 'localization';
import { AjaxContext, WebService } from 'ajax';
import * as $ from 'jquery';

interface IEvents {
	Initialized: boolean;
	GetByName( name: string ): ICategory;
	GetById( id: string ): ICategory;
}

interface ICategory {
	Name: string;
	Selected: boolean;
	EventCount: number;
}

const Events: IEvents = {
		Initialized: false,
		GetByName: () => undefined,
		GetById: () => undefined
	},
	Dialogs = window.Dialogs,
	multiSelect = true,
	locationLimit = 5,
	br =
		$.create( 'br' )
		.attr( { clear: 'all' } )
		.css( { height: 0, 'line-height': 0 } ),
	ajaxContext = new AjaxContext;
let dateStart, dateEnd, byLocation, search;

function updateLocations( locations: IDictionary<ICategory>, push?: boolean ) {
	if( !Events.Initialized ) return undefined;

	if( $( '#flash-map' ).length <= 0 ) return undefined;

	if( typeof locations === 'string' ) locations = $.parseJSON( <any>locations );

	const $locationCheckboxes = $( '#by-location :checkbox' );
		
	function check( checkboxText: string, check?: boolean ) {
		const $locationCheckbox = $locationCheckboxes.filter( ( i, e ) => $(e).closest( 'label' ).text() === checkboxText );
		if( ( check === true ) || ( check === false ) ) {
			$locationCheckbox.prop( 'checked', check );
		} else {
			return !!$locationCheckbox.prop( 'checked' );
		}
		return undefined;
	}

	if( locations && multiSelect ) {
		let numSelected = 0;
		$.each( locations, ( i, e ) => {
			if( e.Selected ) numSelected++;
		} );
	
		if( numSelected > locationLimit ) {
			showLocationLimitDialog();
			return undefined;
		}
	}

	if( locations ) {
		$.each( locations, ( i, e ) => {
			check( e.Name, e.Selected );
		} );

		if( !push ) {
			$( '#by-location' )
				.find( '.criteria-wrapper' )
				.triggerHandler( 'hide' );
		}
			
		search.triggerHandler( 'update' );
	} else {
		locations = {};
		$locationCheckboxes.each( ( i, e ) => {
			const $locationCheckbox = $(e);

			const text = $locationCheckbox.closest( 'label' ).text();

			const location = <ICategory>$.extend( {}, Events.GetByName( text ), { Selected: multiSelect && check( text ) } );
			if( location.Name ) locations[ location.Name ] = location;
		} );
	}
	const jsonResult = $.toJSON( locations );
	if( push ) {
		try {
			(<any>$( '#flash-map' ).get(0)).updateLocations( jsonResult );
		} catch( ex ) {}
	}
	return jsonResult;
}
window[ 'updateLocations' ] = updateLocations;

function eventsSetUp( ids ) {
	const names = {};

	$.each( ids, ( i, e ) => {
		names[ e.Name.toLowerCase() ] = e;
	} );

	Events.GetById = id => ids[ id ];
	Events.GetByName = name => names[ name.toLowerCase() ];

	$.each( $( '#search input:checkbox' ), ( i, e ) => {
		const $checkbox = $(e);
		const id = $checkbox.val();
			
		const cat = Events.GetById( id );
		if( !cat ) return;
		if( cat.EventCount ) {
			$checkbox.prop( 'disabled', false );
			$checkbox.closest( 'li' ).removeClass( 'disabled' );
		} else {
			$checkbox.prop( 'disabled', true );
			$checkbox.closest( 'li' ).addClass( 'disabled' );
		}
	} );

	Events.Initialized = true;

	updateLocations( null, true );
};

ajaxContext.ajax( WebService.getUrl( '/Services/Events/EventJsonCategoryList.ashx' ), {
	type: 'POST',
	data: {
		site: $( 'html' ).data( 'site' ),
		locale: $( 'html' ).attr( 'lang' ),
		w: $.deparam.querystring().w
	},
	dataType: 'json'
} ).then( data => { eventsSetUp( data ); } );

function showLocationLimitDialog() {
	Dialogs.Init( 'Notice', dialogData => {
		translate( 'events/location limit' ).then( itemResult => { dialogData.Open( { message: itemResult.text } ); } );
	} );
};

$( () => {
	translate.defer();

	byLocation = $( '#by-location' );

	search =
		$( '#search' )
		.append( br.clone() )
		.bind( 'update', () => {
			translate.defer();

			const hasCriteria =
				( ( $( '#by-keyword input:text' ).val() || '' ).trim().length > 0 ) ||
				( ( $( '.start-picker' ).val() || '' ).trim().length > 0 ) ||
				( ( $( '.end-picker' ).val() || '' ).trim().length > 0 ) ||
				( $( '#by-location input:checkbox:checked' ).length > 0 ) ||
				( $( '#by-Course-Levels input:checkbox:checked' ).length > 0 ) ||
				( $( '#by-product input:checkbox:checked' ).length > 0 ) ||
				( $( '#by-subject input:checkbox:checked' ).length > 0 ) ||
				( $( '#by-type input:checkbox:checked' ).length > 0 );

			const $searchButton = $( '#events-home .flash-header nav a:eq(1)' );

			translate( hasCriteria ? 'events/find events' : 'events/view all' ).then( itemResult => {
				search
				.find( 'input:submit' )
				.val( itemResult.text );

				$searchButton
				.text( itemResult.text );
			} );
				
			$searchButton
			.attr( { href: '#' } )
			.click( e => {
				e.preventDefault();
				$( '#aspnetForm' )
					.find( '#search' )
					.remove()
					.end()
					.append( search.clone().hide() )
					.submit();
			} );

			$( '#search input.clear' )[ hasCriteria ? 'fadeIn' : 'fadeOut' ]( 1000 );
				
			$( '.ui-dialog #search #tab-list li' )
			.each( ( i, e ) => {
				const indicator = $(e).find( 'span.indicator' );
				const fieldset = $( '.ui-dialog #search fieldset' ).eq( i );
				const checked = fieldset.find( 'input:checkbox:checked' ).length;
				let active = false;
				fieldset.find( 'input:text[name]' ).each( ( i, e ) => {
					if( ( $(e).val() || '' ).trim().length > 0 ) active = true;
					return active;
				} );
				if( checked > 0 ) indicator.text( checked );
				else indicator.text( '\u00a0' );
				if( active || checked > 0 ) indicator.show();
				else indicator.hide();
			} );

			translate.fetch();
		} );
			

	const minDate = '2009-01-01';
	const maxDate = '+4Y';

	if( $( '#events-home' ).length > 0 ) {
		const searchDialog =
			search
			.dialog( {
				autoOpen: false,
				draggable: false,
				resizable: false,
				show: { effect: 'fade' },
				hide: { effect: 'fade' },
				modal: true,
				width: 603,
				dialogClass: 'advanced-search-dialog',
				position: {
					my: 'center top',
					at: 'center top',
					of: '.event-landing'
				}
			} );

		search.find( ':submit' ).click( e => {
			e.preventDefault();
			searchDialog.dialog( 'close' );
			$( '#aspnetForm' ).append( search ).submit();
		} );
			
		//searchDialog.parent().appendTo( $body );
			
		const tabList =
			$.create( 'ul' )
			.attr( { id: 'tab-list' } );

		const cancelButton = 
			$.create( 'input' )
			.attr( { type: 'button' } )
			.click( () => {
				search.dialog( 'close' );
				tabList.children( 'li' ).removeClass( 'selected' );
				search.find( 'fieldset' ).hide();
				search.find( ':text' ).val( '' );
				search.find( ':selected' ).parent().children().eq( 0 ).prop( 'selected', true );
				if( multiSelect ) search.find( 'fieldset:not( #by-location ) :checked' ).prop( 'checked', false );
				else search.find( 'fieldset :checked' ).prop( 'checked', false );
				search.triggerHandler( 'update' );
			} );

		translate( 'events/cancel' ).then( itemResult => {
			cancelButton.val( itemResult.text );
		} );
			
		search
		.find( 'input[type="submit"]' )
		.wrap(
			$.create( 'div' )
			.addClass( 'buttons' )
		)
		.before( cancelButton );

		search
		.prepend( tabList )
		.find( 'fieldset' )
		.each( ( i, e ) => {
			const fieldset = $(e);
			tabList
			.append(
				$.create( 'li' )
				.append(
					$.create( 'a' )
					.attr( { href: '#' } )
					.text( fieldset.find( 'legend' ).text() )
					.bind( 'select', e => {
						tabList.children( 'li' ).removeClass( 'selected' );
						$(e.target).closest( 'li' ).addClass( 'selected' );

						search.find( 'fieldset' ).hide();

						fieldset.show();
						search.height( fieldset.height() );
					} )
					.click( e => {
						e.preventDefault();
						$(e.target).triggerHandler( 'select' );
					} )
				)
				.append(
					$.create( 'span' )
					.addClass( 'indicator' )
					.hide()
				)
			);
		} );

		const advancedSearchButton =
			$.create( 'a' )
			.attr( { href: '#', id: 'advanced-search' } )
			.click( e => {
				e.preventDefault();
				searchDialog.dialog( 'open' );

				tabList
				.find( 'li:eq(0) a' )
				.triggerHandler( 'select' );
			} )
			.prependTo( '.flash-header nav' );

		translate( 'events/advanced search' ).then( itemResult => {
			advancedSearchButton.text( itemResult.text );
		} );
	}

	search
	.find( 'input:submit' )
	.clone( true )
	.insertBefore( '.sublayout-two-column-callout-left #search #by-keyword' );
	
	$( '.sublayout-two-column-callout-left #search' )
	.children( 'fieldset' )
	.each( ( i, fieldset ) => {
		const $fieldset = $(fieldset);
	
		const id = $fieldset.attr( 'id' ).toLowerCase();
	
		const $legend = $fieldset.children( 'legend' ).eq( 0 );
	
		let wrapper, wrapperHeader, wrapperBody, wrapperFooter;
	
		const updateButton = 
			$.create( 'a' )
			.attr( { href: '#' } )
			.addClass( 'collapse-link' )
			.hide()
			.click( e => {
				e.preventDefault();
				wrapper.triggerHandler( 'hide' );
			} );

		translate( 'events/close' ).then( itemResult => {
			updateButton.text( itemResult.text );
		} );
	
		const placeholder =
			$.create( 'div' )
			.addClass( 'placeholder' )
			.hide()
			.bind( 'update', () => {
				placeholder
				.empty()
				.css( { height: 0 } )
				.hide();
	
				const remove =
					$.create( 'a' )
					.addClass( 'remove-button' )
					.attr( { href: '#' } )
					.click( e => {
						e.preventDefault();
						$(e.target).triggerHandler( 'myremove' );
						search.triggerHandler( 'update' );
						placeholder.slideUp( 'slow', () => {
							placeholder
							.triggerHandler( 'update' );
	
							if( !placeholder.is( ':empty' ) ) {
								placeholder
								.slideDown( 'slow' );
							}
						} );
					} );

				translate( 'events/clear' ).then( itemResult => {
					remove.val( itemResult.text );
				} );
	
				let ul;
				switch( id ) {
				case 'by-keyword':
					const $txtKeyword = $( '#by-keyword :text' ).eq( 0 );
					const kv = ( $txtKeyword.val() || '' ).trim();
					if( !kv ) break;
	
					placeholder
					.append(
						$.create( 'p' )
						.prepend(
							remove
							.clone( true )
							.text( kv )
							.bind( 'myremove', () => { $txtKeyword.val( '' ); } )
						)
					);
					break;
				case 'by-date':
					const a = $( '.start-picker' ).eq( 0 );
					const av = a.val();
					const b = $( '.end-picker' ).eq( 0 );
					const bv = b.val();

					if( $( '#by-date #range-selector option:selected' ).val() ) {
						$.create( 'p' )
						.prepend(
							remove
							.clone( true )
							.text( $( '#by-date #range-selector option:selected' ).text() )
							.bind( 'myremove', () => {
								if( dateStart ) dateEnd.datepicker( 'option', { minDate, maxDate } );
								if( dateEnd ) dateEnd.datepicker( 'option', { minDate, maxDate } );
								a.val( '' );
								b.val( '' );

								$( '#by-date #range-selector :selected' )
								.parent()
								.children()
								.eq( 0 )
								.prop( 'selected', true );
							} )
						)
						.appendTo( placeholder );
						break;
					}

					ul = $.create( 'ul' );
					if( av ) {
						$.create( 'li' )
						.prepend(
							remove
							.clone( true )
							.text( a.closest( 'label' ).text() + av )
							.bind( 'myremove', () => {
								if( dateEnd ) dateEnd.datepicker( 'option', { minDate } );
								a.val( '' );

								$( '#by-date #range-selector' ).triggerHandler( 'update' );
							} )
						)
						.appendTo( ul );
					}
					if( bv ) {
						$.create( 'li' )
						.prepend(
							remove
							.clone( true )
							.text( b.closest( 'label' ).text() + bv )
							.bind( 'myremove', () => {
								if( dateStart ) dateStart.datepicker( 'option', { maxDate } );
								b.val( '' );

								$( '#by-date #range-selector' ).triggerHandler( 'update' );
							} )
						)
						.appendTo( ul );	
					}
					if( ul.children( 'li' ).length > 0 ) {
						placeholder.append( ul );
					}
					break;
				case 'by-location':
				case 'by-course-levels':
				case 'by-product':
				case 'by-subject':
				case 'by-type':
					ul = $.create( 'ul' );
					wrapperBody.find( 'input:checkbox:checked' ).each( ( i, checkbox ) => {
						const $checkbox = $(checkbox);
						const t = $checkbox.closest( 'label' ).text();
	
						$.create( 'li' )
						.prepend(
							remove
							.clone( true )
							.text( t )
							.bind( 'myremove', () => {
								$checkbox.prop( 'checked', false );
									
								switch( id ) {
								case 'by-location':
									updateLocations( null, true );
									break;
								}
							} )
						)
						.appendTo( ul );
					} );
					if( ul.children( 'li' ).length > 0 ) placeholder.append( ul );
					break;
				}
	
				search.triggerHandler( 'update' );

				if( !placeholder.is( ':empty' ) ) {
					placeholder.css( { height: 'auto' } );
				}
			} );
	
		wrapperBody =
			$legend
			.nextAll()
			.wrapAll(
				$.create( 'div' )
				.addClass( 'criteria-wrapper-body' )
				.hide()
			)
			.parent( 'DIV' );
	
		const $wrapperHeading = $.create( 'h4' );
		translate( 'events/header/' + id ).then( itemResult => {
			$wrapperHeading.text( itemResult.text );
		} );

		wrapperHeader =
			$.create( 'div' )
			.addClass( 'criteria-wrapper-header' )
			.hide()
			.append( $wrapperHeading )
			.append( updateButton );
	
		wrapperFooter =
			$.create( 'div' )
			.addClass( 'criteria-wrapper-footer' )
			.hide();

		wrapper =
			$.create( 'div' )
			.addClass( 'criteria-wrapper' )
			.hide()
			.append( wrapperHeader )
			.append( wrapperBody )
			.append( wrapperFooter )
			.bind( 'show', () => {
				$( '.criteria-wrapper' ).each( ( i, t ) => {
					const $t = $( t );
					if( $t.closest( 'fieldset' ).attr( 'id' ) !== wrapper.closest( 'fieldset' ).attr( 'id' ) ) $t.triggerHandler( 'hide' );
				} );
	
				function f() {
					wrapperHeader
					.stop( true, true )
					.fadeIn( 'slow',
						() => {
							$legend.css( { visibility: 'hidden' } );

							wrapperBody
							.stop( true, true )
							.slideDown( 'slow', () => {
								updateButton
								.prop( 'disabled', false )
								.stop( true, true )
								.fadeIn( 'slow' );
								wrapperFooter
								.stop( true, true )
								.slideDown( 'fast' );
							} );
						}
					);
				}
	
				wrapper.show();
				if( !placeholder.is( ':empty' ) ) {
					placeholder
					.stop( true, true )
					.slideUp( 'slow', f );
				} else {
					placeholder
					.stop( true, true )
					.hide();
					f();
				}
			} )
			.bind( 'hide', () => {
				wrapperFooter.stop( true, true );
				wrapperBody.stop( true, true );
				wrapperHeader.stop( true, true );
				updateButton
				.prop( 'disabled', true )
				.stop( true, true )
				.fadeOut( 'slow' );
	
				placeholder
				.stop( true, true )
				.slideUp( 'slow' )
				.triggerHandler( 'update' );
	
				wrapperFooter
				.stop( true, true )
				.slideUp( 'fast', () => {
					wrapperBody
					.stop( true, true )
					.slideUp( 'slow',
						() => {
							$legend.css( { visibility: 'visible' } );

							wrapperHeader
							.stop( true, true )
							.fadeOut( 'slow',
								() => {
									wrapper
									.stop( true, true )
									.hide();
									if( !placeholder.is( ':empty' ) ) {
										placeholder
										.stop( true, true )
										.slideDown( 'slow' );
									}
								}
							);
						}
					);
				} );
			} )
			.insertAfter( $legend )
			.before(
				placeholder
			);
	
		wrapper.find( 'ul' ).after( br.clone() );
	
		$legend
		.wrapInner(
			$.create( 'a' )
			.attr( { href: '#' } )
			.click( e => {
				e.preventDefault();
				wrapper.triggerHandler( 'show' );
			} )
		);
	
		placeholder.triggerHandler( 'update' );
		if( !placeholder.is( ':empty' ) ) placeholder.show();
	} );
	
	search
	.find( 'input,select,textarea' )
	.keyup( () => {
		search.triggerHandler( 'update' );
	} )
	.change( () => {
		search.triggerHandler( 'update' );
	} )
	.click( () => {
		search.triggerHandler( 'update' );
	} );

	function byLocationCheckEvent( e ) {
		if( byLocation.find( 'input:checkbox:checked' ).length <= locationLimit ) {
			updateLocations( null, true );
		} else {
			if( e.target.checked ) {
				e.preventDefault();
				showLocationLimitDialog();
			}
		}
		search
		.triggerHandler( 'update' );
	}
	
	byLocation
	.find( 'input:checkbox' )
	.click( byLocationCheckEvent );
		
	const $clearButton =
		$.create( 'input' )
		.attr( {
			type: 'button'
		} )
		.addClass( 'clear' )
		.click( () => {
			search.find( ':text' ).val( '' );
			search.find( ':selected' ).parent().children().eq( 0 ).prop( 'selected', true );
			search.find( ':checked' ).prop( 'checked', false );
			
			$( '.criteria-wrapper' ).each( ( i, e ) => {
				$( e ).triggerHandler( 'hide' );
			} );
			search.triggerHandler( 'update' );
			updateLocations( null, true );
		} )
		.hide()
		.insertAfter( '#search input[type="submit"]:eq(1)' );

	translate( 'events/clear' ).then( itemResult => {
		$clearButton.val( itemResult.text );
	} );

	$( '#content' )
	.append( br.clone() );

	if( $( '#by-date' ).length > 0 ) ( () => {
		const textStart = $( '.start-picker' ).eq( 0 );
		const textEnd = $( '.end-picker' ).eq( 0 );

		$( '#by-date' )
		.find( 'input:text' )
		.prop( 'readonly', true )
		.wrap( $.create( 'span' ) );

		dateStart = 
			$( '.start-picker' )
			.datepicker( {
				navigationAsDateFormat: true,
				showOn: 'both',
				buttonImage: '/App_Themes/Default/images/events/calendar-icon.gif',
				buttonImageOnly: true,
				showAnim: 'fade',
				dateFormat: $.datepicker.W3C,
				minDate,
				maxDate: textEnd.val().trim(),
				changeMonth: true,
				changeYear: true
			} ).change( e => {
				const v = $(e.target).val();
				if( !v ) return;

				textEnd.datepicker( 'option', { minDate: textStart.val().trim() } );
		} );

		dateEnd =
			textEnd
			.datepicker( {
				navigationAsDateFormat: true,
				showOn: 'both',
				buttonImage: '/App_Themes/Default/images/events/calendar-icon.gif',
				buttonImageOnly: true,
				showAnim: 'fade',
				dateFormat: $.datepicker.W3C,
				minDate: textStart.val().trim(),
				maxDate,
				changeMonth: true,
				changeYear: true
			} ).change( e => {
				const v = $(e.target).val();
				if( !v ) return;
					
				textStart.datepicker( 'setDate', textStart.val().trim() );
				textStart.datepicker( 'option', { maxDate: textEnd.val().trim() } );
		} );
			
		const today = new Date;
		const next30 = new Date;
		next30.setDate(today.getDate() + 30);
		const next60 = new Date;
		next60.setDate(today.getDate() + 60);
		const next90 = new Date;
		next90.setDate(today.getDate() + 90);
		const next180 = new Date;
		next180.setDate(today.getDate() + 180);
		const nextYear = new Date;
		nextYear.setDate(today.getDate() + 365);

		const past30 = new Date;
		past30.setDate(today.getDate() - 30);
		const past60 = new Date;
		past60.setDate(today.getDate() - 60);
		const past90 = new Date;
		past90.setDate(today.getDate() - 90);
		const past180 = new Date;
		past180.setDate(today.getDate() - 180);
		const pastYear = new Date;
		pastYear.setDate(today.getDate() - 365);

		const $rangeSelector =
			$.create( 'select' )
			.attr( { id: 'range-selector' } );

		function addItem( text, value ) {
			//if( typeof value === 'number' ) value = new Date( value, 0, 1 );
			if( value instanceof Date ) value = value.getFullYear() + '-' + (value.getMonth()+1) + '-' + value.getDate();

			const $option =
				$.create( 'option' )
				.attr( { value } )
				.text( text.toString() );

			$rangeSelector.append( $option );

			return $option;
		}

		function addItemLocalized( textKey, value ) {
			const $option = addItem( textKey, value );

			translate( textKey ).then( itemResult => {
				$option.text( itemResult.text );

				$( '#by-date .remove-button' )
				.filter( ( i, e ) => $(e).text() === itemResult.itemPath.toLowerCase() )
				.text( itemResult.text );
			} );
		}
		
		addItemLocalized( 'events/date/select a range', '' );
		addItemLocalized( 'events/date/next 30', next30 );
		addItemLocalized( 'events/date/next 60', next60 );
		addItemLocalized( 'events/date/next 90', next90 );
		addItemLocalized( 'events/date/next 180', next180 );
		addItemLocalized( 'events/date/next year', nextYear );
		addItemLocalized( 'events/date/past 30', past30 );
		addItemLocalized( 'events/date/past 60', past60 );
		addItemLocalized( 'events/date/past 90', past90 );
		addItemLocalized( 'events/date/past 180', past180 );
		addItemLocalized( 'events/date/past year', pastYear );

		for( let i = new Date().getFullYear() - 1; i >= 2009; i-- ) {
			addItem( i, i );
		}

		$rangeSelector
		.change( e => {
			const v = $(e.target).val();
			if( !v ) return;

			textStart.datepicker( 'option', { minDate, maxDate } );
			textEnd.datepicker( 'option', { minDate, maxDate } );

			let ds, de;

			if( v.indexOf( '-' ) >= 0 ) {
				const currentDate = new Date();
				const otherDate = $.datepicker.parseDate( $.datepicker.W3C, v );
				if( currentDate < otherDate ) {
					ds = currentDate;
					de = otherDate;
				} else {
					ds = otherDate;
					de = currentDate;
				}
			} else {
				const i = parseInt( v, 10 );
				ds = new Date( i, 0, 1, 0, 0, 0, 0 );
				de = new Date( i, 11, 31, 0, 0, 0, 0 );
			}
				
			dateStart.datepicker( 'setDate', ds );
			dateEnd.datepicker( 'setDate', de );

			textStart.val( $.datepicker.formatDate( $.datepicker.W3C, ds ) );
			textEnd.val( $.datepicker.formatDate( $.datepicker.W3C, de ) );

			textStart.datepicker( 'option', { minDate, maxDate: de } );
			textEnd.datepicker( 'option', { minDate: ds, maxDate } );

			search.triggerHandler( 'update' );
		} )
		.insertBefore( '#by-date label:eq(0)' );
			
			
		$rangeSelector
		.bind( 'update', e => {
			$(e.target).children( 'option' ).prop( 'selected', false );
			const sdt = textStart.val().trim();
			const edt = textEnd.val().trim();
			if( sdt && edt ) {
				const sd = $.datepicker.parseDate( $.datepicker.W3C, sdt );
				const ed = $.datepicker.parseDate( $.datepicker.W3C, edt );
				$.each( $( '#by-date #range-selector option' ), ( i, e ) => {
					const t = $(e);
					const v = t.val();
					if( !v ) return;
					let startDate, endDate;
					if( v.indexOf( '-' ) >= 0 ) {
						const currentDate = new Date();
						currentDate.setHours( 0 );
						currentDate.setMinutes( 0 );
						currentDate.setSeconds( 0 );
						currentDate.setMilliseconds( 0 );
						const otherDate = $.datepicker.parseDate( $.datepicker.W3C, v );
						if( currentDate < otherDate ) {
							startDate = currentDate;
							endDate = otherDate;
						} else {
							startDate = otherDate;
							endDate = currentDate;
						}
					} else {
						const i = parseInt( v, 10 );
						startDate = new Date( i, 0, 1, 0, 0, 0, 0 );
						endDate = new Date( i, 11, 31, 0, 0, 0, 0 );
					}
					if( !( ( startDate < sd ) || ( startDate > sd ) || ( endDate < ed ) || ( endDate > ed ) ) ) {
						t.prop( 'selected', true );
						$( '#by-date .placeholder' ).triggerHandler( 'update' );
						if( !$( '#by-date .criteria-wrapper' ).is( ':visible' ) ) $( '#by-date .placeholder' ).show();
					}
				} );
			}
		} )
		.triggerHandler( 'update' );
	} )();
	search.triggerHandler( 'update' );

	if( location.href.indexOf( '?print&' ) >= 0 ) {
		print();
	}

	$( '#navigation-events ul li' ).attr( 'id', function() {
// HACK: stupid, stupid code for icons
		return 'section-' + $( 'a', this ).html().toLowerCase();
	} );

	translate.fetch();
} );
